import React, { useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";

export interface ColumnDef {
  id: string;
  label: string;
}

export interface ColumnToggleProps {
  columns: ColumnDef[];
  visibleColumns: Set<string>;
  onChange: (next: Set<string>) => void;
}

export function ColumnToggle({ columns, visibleColumns, onChange }: ColumnToggleProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title="Toggle columns">
        <IconButton
          size="small"
          onClick={e => setAnchorEl(e.currentTarget)}
          aria-label="Toggle column visibility"
        >
          <ViewColumnIcon />
        </IconButton>
      </Tooltip>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ p: 2, minWidth: 160 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Show / Hide Columns
          </Typography>
          <FormGroup>
            {columns.map(col => (
              <FormControlLabel
                key={col.id}
                control={
                  <Checkbox
                    checked={visibleColumns.has(col.id)}
                    onChange={e => {
                      const next = new Set(visibleColumns);
                      if (e.target.checked) next.add(col.id);
                      else next.delete(col.id);
                      onChange(next);
                    }}
                    size="small"
                  />
                }
                label={col.label}
              />
            ))}
          </FormGroup>
        </Box>
      </Popover>
    </>
  );
}
